// extracted by mini-css-extract-plugin
module.exports = {"pg-use-box":"dy","pgUseBox":"dy","use-card-wrap":"dz","useCardWrap":"dz","use-box-wrap":"dA","useBoxWrap":"dA"};